import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../components/Loader";
import styles from "./pets.module.css";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Snackbar, Typography } from "@mui/material";
import { ArrowLeft, Home, X } from "react-feather";
import { Helmet } from "react-helmet";
import Footer from "../../components/Footer";
import { useState, useEffect } from "react";
import axios from "axios";
import PetListView from "./components/listview/PetListView";
import PetGridView from "./components/gridview/PetGridView";
import PetAddForm from "./components/AddForm";
import { toast } from "react-smart-toaster";
import PetEditForm from "./components/EditForm";
import withCustomAuthenticationRequired from "../../auth/withCustomAuthenticationRequired";

const Pets = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [isGridView, setIsGridView] = useState(false);
  const [hasGridRendered, setHasGridRendered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [filterredData, setFilterredData] = useState([]);
  const [listChangeCounter, setListChangeCounter] = useState(0);
  const [filterData, setFilterData] = useState({ searchKey: "", property: "", apartment: "", type: "" });
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [deletePetModalOpen, setDeletePetModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [editData, setEditData] = useState(null);

  const handleView = (view) => {
    if (view === "grid") {
      setIsGridView(true);
      setHasGridRendered(true);
    } else {
      setIsGridView(false);
    }
  };

  useEffect(() => {
    async function getPets() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_TENANT_API_URL + "v1/pets", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    }
    getPets();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    let filterredDataTemp = allData?.filter((i) => i?.tenant_id);

    if (filterData?.searchKey !== "") {
      let inputVal = filterData?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredDataTemp = filterredDataTemp.filter(
        (item) => item?.tenant_name.toLowerCase().includes(inputVal) || item?.title.toLowerCase().includes(inputVal) || item?.type.toLowerCase().includes(inputVal) || item?.weight.toLowerCase().includes(inputVal) || item?.color.toLowerCase().includes(inputVal) || item?.property_name.toLowerCase().includes(inputVal) || item?.apt_no.toLowerCase().includes(inputVal));
    }

    if (filterData?.property !== "" && filterData?.property !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => i?.property_id === filterData.property);
    }

    if (filterData?.apartment !== "" && filterData?.apartment !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => i?.apt_id === filterData.apartment);
    }

    if (filterData?.type !== "" && filterData?.type !== "all") {
      filterredDataTemp = filterredDataTemp.filter((i) => i?.is_guest === filterData.type);
    }

    if (!filterData?.searchKey && (filterData?.apartment !== "" || filterData?.property !== "")) {
      setListChangeCounter((p) => p + 1);
    }

    setFilterredData(filterredDataTemp);
  }, [allData, filterData]);

  const onAdd = (data) => {
    setListChangeCounter((p) => p + 1);
    setAllData((prev) => {
      return [data].concat(prev);
    });
  };

  const onUpdate = (data) => {
    setListChangeCounter((p) => p + 1);
    setAllData((prev) => {
      return prev?.map((i) => {
        if (i?.id === data?.id) return data;
        return i;
      });
    });
  };

  const deleteConfirm = async () => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    setDeletePetModalOpen(false);
    setLoading(true);

    axios.delete(process.env.REACT_APP_TENANT_API_URL + "v1/pets/" + selectedId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      setAllData((prev) => {
        return prev?.filter((i) => i?.id !== selectedId);
      });
      setListChangeCounter((p) => p + 1);
      setSelectedId(0);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  return (<>
    {loading && <Loader />}
    <Helmet title="Pet" />
    <div className={`${styles.pageTitleWrap}`}>
      <Typography display="inline" className={`${styles.pageTitle}`}>Pets</Typography>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Pet</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>Lists</li>
        </ol>
      </nav>
    </div>

    {/* List View */}
    <div style={{ display: isGridView ? "none" : "block" }}>
      <PetListView
        contentLoading={contentLoading}
        allData={filterredData}
        isGridView={isGridView}
        handleView={handleView.bind(this)}
        filterData={filterData}
        setFilterData={setFilterData.bind(this)}
        setAddModalOpen={setAddModalOpen.bind(this)}
        setSelectedId={setSelectedId.bind(this)}
        setEditData={setEditData.bind(this)}
        setEditModalOpen={setEditModalOpen.bind(this)}
        isListChange={listChangeCounter}
      />
    </div>

    {/* Grid View */}
    {hasGridRendered && (<div style={{ display: isGridView ? "block" : "none" }}>
      <PetGridView
        contentLoading={contentLoading}
        allData={filterredData}
        isGridView={isGridView}
        handleView={handleView.bind(this)}
        filterData={filterData}
        setFilterData={setFilterData.bind(this)}
        setAddModalOpen={setAddModalOpen.bind(this)}
        setDeletePetModalOpen={setDeletePetModalOpen.bind(this)}
        setSelectedId={setSelectedId.bind(this)}
        setEditData={setEditData.bind(this)}
        setEditModalOpen={setEditModalOpen.bind(this)}
      />
    </div>)}

    <Dialog
      open={addModalOpen}
      onClose={(e) => setAddModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setAddModalOpen(false)}>
          <ArrowLeft />
        </button>
        Add New Pet
        <button onClick={(e) => setAddModalOpen(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent className={`${styles.RequestBodyPop}`}>
        <PetAddForm
          setAddModalOpen={setAddModalOpen.bind(this)}
          setLoading={setLoading.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          setSnackbarMsg={setSnackbarMsg.bind(this)}
          onSubmitLocal={onAdd.bind(this)}
        />
      </DialogContent>
    </Dialog>

    <Dialog
      open={editModalOpen}
      onClose={(e) => setEditModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setEditModalOpen(false)}>
          <ArrowLeft />
        </button>
        Update Pet
        <button onClick={(e) => setEditModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent className={`${styles.RequestBodyPop}`}>
        <PetEditForm
          setAddModalOpen={setEditModalOpen.bind(this)}
          setLoading={setLoading.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          setSnackbarMsg={setSnackbarMsg.bind(this)}
          onSubmitLocal={onUpdate.bind(this)}
          editData={editData}
        />
      </DialogContent>
    </Dialog>

    <Dialog
      open={deletePetModalOpen}
      onClose={(e) => setDeletePetModalOpen(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Would you like to delete this pet?
        <button onClick={(e) => setDeletePetModalOpen(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <div className="ModalFormGroup">
          <label className="PopupBodyText">The pet information will be removed immediately. You can't undo this action.</label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => deleteConfirm(false)} className="CancelPopupBU">Delete</Button>
        <Button onClick={(e) => setDeletePetModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

    <Footer />
  </ >);
};

export default withCustomAuthenticationRequired(Pets, {
  onRedirecting: () => <Loader />,
});
